import { render, staticRenderFns } from "./PopoverModal.vue?vue&type=template&id=2f25ec2e&scoped=true"
import script from "./PopoverModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopoverModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PopoverModal.vue?vue&type=style&index=0&id=2f25ec2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f25ec2e",
  null
  
)

export default component.exports